import { i18n } from '../i18n';

export const MESSAGES = {
  AUTH: {
    SUCCESS: {
      LOG_OUT: i18n.t('messages.auth.success.logOut'),
      RESET_PASSWORD_INSTRUCTIONS: i18n.t('messages.auth.success.resetPasswordInstructions'),
      CHANGE_PASSWORD: i18n.t('messages.auth.success.changePassword'),
    },
    WARNING: {
      RETRY_LOGIN: i18n.t('messages.auth.warning.retryLogin'),
    },
    ERROR: {
      ACCOUNT_NOT_FOUND: i18n.t('messages.auth.error.accountNotFound'),
      INVALID_TOKEN: i18n.t('messages.auth.error.invalidToken'),
      NOT_LOGGED_IN: i18n.t('messages.auth.error.notLoggedIn'),
      NOT_UPDATED_PASSWORD: i18n.t('messages.auth.error.notUpdatedPassword'),
      NOT_CHANGED_PASSWORD: i18n.t('messages.auth.error.notChangedPassword'),
      NOT_RESET_PASSWORD: i18n.t('messages.auth.error.notResetPassword'),
    },
  },
  NOTIFICATIONS: {
    SUCCESS: {
      DELETE: i18n.t('messages.notifications.success.delete'),
      READ: i18n.t('messages.notifications.success.read'),
    },
    ERROR: {
      NOT_DELETED: i18n.t('messages.notifications.error.notDeleted'),
      NOT_READ: i18n.t('messages.notifications.error.notRead'),
    },
  },
  CONTAINERS: {
    SUCCESS: {
      GATED_IN: i18n.t('messages.containers.success.gatedIn'),
      GATED_OUT: i18n.t('messages.containers.success.gatedOut'),
      DELETED: i18n.t('messages.containers.success.deleted'),
      EDITED: i18n.t('messages.containers.success.edited'),
      FILES_CHANGE: i18n.t('messages.containers.success.filesChange'),
      TRANSFER: i18n.t('messages.containers.success.transfer'),
      SALE: i18n.t('messages.containers.success.sale'),
      REPAIR: i18n.t('messages.containers.success.repair'),
      HOLD: i18n.t('messages.containers.success.hold'),
      RELEASE_HOLD: i18n.t('messages.containers.success.releaseHold'),
    },
    WARNING: {
      ALREADY_SALE: i18n.t('messages.containers.warning.alreadySale'),
      SALE_IMAGE: i18n.t('messages.containers.warning.saleImage'),
      SALE_STATUS: i18n.t('messages.containers.warning.saleStatus'),
      SALE_HOLD_STATUS: i18n.t('messages.containers.warning.saleHoldStatus'),
      SALE_CAN_TRADE: i18n.t('messages.containers.warning.saleCanTrade'),
      HOLD_RELEASE_STATUS: i18n.t('messages.containers.warning.holdReleaseStatus'),
      HOLD_STATUS_GATED_IN: i18n.t('messages.containers.warning.holdStatusGatedIn'),
      HOLD_SALE_STATUS: i18n.t('messages.containers.warning.holdSaleStatus'),
      ALREADY_EXISTS: (containers: string) =>
        i18n.t('messages.containers.warning.alreadyExists', { containers }),
      NOT_SELECTED: (containers: string) =>
        i18n.t('messages.containers.warning.notSelected', { containers }),
    },
    ERROR: {
      NOT_DELETED: i18n.t('messages.containers.error.notDeleted'),
      NOT_EDITED: i18n.t('messages.containers.error.notEdited'),
      NOT_REPAIRED: i18n.t('messages.containers.error.notRepaired'),
      NOT_SELL: i18n.t('messages.containers.error.notSell'),
      NOT_TRANSFERRED: i18n.t('messages.containers.error.notTransferred'),
      DUPLICATED: i18n.t('messages.containers.error.duplicated'),
    },
  },
  GATE_IN: {
    SUCCESS: {
      COMPLETED: i18n.t('messages.gateIn.success.completed'),
      EDIT: i18n.t('messages.gateIn.success.edit'),
      DELETED: i18n.t('messages.gateIn.success.deleted'),
    },
    ERROR: {
      NOT_COMPLETED: i18n.t('messages.gateIn.error.notCompleted'),
      NOT_EDITED: i18n.t('messages.gateIn.error.notEdited'),
      NOT_DELETED: i18n.t('messages.gateIn.error.notDeleted'),
      CONTAINER_DUPLICATED: i18n.t('messages.gateIn.error.containerDuplicated'),
    },
  },
  GATE_OUT: {
    SUCCESS: {
      LOADING_ALLOWED: i18n.t('messages.gateOut.success.loadingAllowed'),
      LOADED: i18n.t('messages.gateOut.success.loaded'),
      COMPLETED: i18n.t('messages.gateOut.success.completed'),
      EXTENDED: i18n.t('messages.gateOut.success.extended'),
      EDIT: i18n.t('messages.gateOut.success.edit'),
      DELETED: i18n.t('messages.gateOut.success.deleted'),
      CREATED_FILTER: (count: number) =>
        i18n.t('messages.gateOut.success.createdFilter', { count }),
      CREATED_FROM_FILTER: i18n.t('messages.gateOut.success.createdFromFilter'),
    },
    ERROR: {
      NOT_COMPLETED: i18n.t('messages.gateOut.error.notCompleted'),
      NOT_EDITED: i18n.t('messages.gateOut.error.notEdited'),
      NOT_DELETED: i18n.t('messages.gateOut.error.notDeleted'),
      NOT_CREATED_FILTER: i18n.t('messages.gateOut.error.notCreatedFilter'),
      NOT_CREATED_FROM_FILTER: i18n.t('messages.gateOut.error.notCreatedFromFilter'),
    },
  },
  REPAIR: {
    SUCCESS: {
      UPDATED: i18n.t('messages.repair.success.updated'),
      APPROVED: i18n.t('messages.repair.success.approved'),
      REJECTED: i18n.t('messages.repair.success.rejected'),
      COMPLETED: i18n.t('messages.repair.success.completed'),
      INVOICE_CREATED: i18n.t('messages.repair.success.invoiceCreated'),
      DELETED: i18n.t('messages.repair.success.deleted'),
    },
    ERROR: {
      NOT_CLIENT_CONFIRMED: i18n.t('messages.repair.error.notClientConfirmed'),
      NOT_COMPLETED: i18n.t('messages.repair.error.notCompleted'),
      NOT_DELETED: i18n.t('messages.repair.error.notDeleted'),
      NOT_SET: i18n.t('messages.repair.error.notSet'),
    },
  },
  INVENTORY: {
    SUCCESS: {
      ADDED: i18n.t('messages.inventory.success.added'),
      UPDATED: i18n.t('messages.inventory.success.updated'),
      COMPLETED: i18n.t('messages.inventory.success.completed'),
      DELETED: i18n.t('messages.inventory.success.deleted'),
    },
    ERROR: {
      NOT_ADDED: i18n.t('messages.inventory.error.notAdded'),
      NOT_UPDATED: i18n.t('messages.inventory.error.notUpdated'),
      NOT_COMPLETED: i18n.t('messages.inventory.error.notCompleted'),
      NOT_DELETED: i18n.t('messages.inventory.error.notDeleted'),
    },
  },
  STORAGE_PRICING: {
    SUCCESS: {
      ADDED: i18n.t('messages.storagePricing.success.added'),
      UPDATED: i18n.t('messages.storagePricing.success.updated'),
    },
  },
  INVOICE: {
    SUCCESS: {
      CREATED: i18n.t('messages.invoice.success.created'),
      PENDING: i18n.t('messages.invoice.success.pending'),
      PAID: i18n.t('messages.invoice.success.paid'),
      DELETED: i18n.t('messages.invoice.success.deleted'),
    },
  },
  MARKETPLACE: {
    SUCCESS: {
      BUY: i18n.t('messages.marketplace.success.buy'),
      SEND_OFFER: i18n.t('messages.marketplace.success.sendOffer'),
      DELETE: i18n.t('messages.marketplace.success.delete'),
    },
    ERROR: {
      NOT_BUYED: i18n.t('messages.marketplace.error.notBuyed'),
      NOT_SEND_OFFER: i18n.t('messages.marketplace.error.notSendOffer'),
    },
  },
  MANAGE_SALES: {
    SUCCESS: {
      EDIT: i18n.t('messages.manageSales.success.edit'),
    },
    ERROR: {
      NOT_DELETED: i18n.t('messages.manageSales.error.notDeleted'),
      NOT_EDITED: i18n.t('messages.manageSales.error.notEdited'),
    },
  },
  OFFER: {
    SUCCESS: {
      ACCEPT: i18n.t('messages.offer.success.accept'),
      REJECT: i18n.t('messages.offer.success.reject'),
      MARK_AS_PAID: i18n.t('messages.offer.success.markAsPaid'),
      MARK_AS_UNPAID: i18n.t('messages.offer.success.markAsUnpaid'),
      MARK_AS_INSTALLMENT: i18n.t('messages.offer.success.markAsInstallment'),
      UPDATE: i18n.t('messages.offer.success.update'),
      CANCEL: i18n.t('messages.offer.success.cancel'),
      CANCEL_PAID: i18n.t('messages.offer.success.cancelPaid'),
    },
    ERROR: {
      NOT_CANCELLED: i18n.t('messages.offer.error.notCanceled'),
      NOT_CANCELED_PAID: i18n.t('messages.offer.error.notCanceledPaid'),
      NOT_CONFIRMED: i18n.t('messages.offer.error.notConfirmed'),
      NOT_CONFIRMED_PAYMENT: i18n.t('messages.offer.error.notConfirmedPayment'),
      NOT_UPDATED: i18n.t('messages.offer.error.notUpdated'),
    },
  },
  CART: {
    SUCCESS: { REMOVE: i18n.t('messages.cart.success.remove') },
  },
  SALES_FEE: {
    SUCCESS: {
      ADDED: i18n.t('messages.salesFee.success.added'),
      UPDATED: i18n.t('messages.salesFee.success.updated'),
    },
  },
  BELONGS_TO: {
    SUCCESS: {
      CREATED: i18n.t('messages.belongsTo.success.created'),
      UPDATED: i18n.t('messages.belongsTo.success.updated'),
    },
    ERROR: {
      NOT_CREATED: i18n.t('messages.belongsTo.error.notCreated'),
      NOT_UPDATED: i18n.t('messages.belongsTo.error.notUpdated'),
    },
  },
  CLIENT: {
    SUCCESS: {
      ASSIGN_YARDS: i18n.t('messages.client.success.assignYards'),
      DEACTIVATED_YARDS: i18n.t('messages.client.success.deactivatedYards'),
      REACTIVATED_YARDS: i18n.t('messages.client.success.reactivatedYards'),
    },
    ERROR: {
      YARDS_NOT_ASSIGNED: i18n.t('messages.client.error.yardsNotAssigned'),
      YARDS_NOT_DEACTIVATED: i18n.t('messages.client.error.yardsNotDeactivated'),
      YARDS_NOT_REACTIVATED: i18n.t('messages.client.error.yardsNotReactivated'),
      NOT_SEND_CONTRACT: i18n.t('messages.client.error.notSendContract'),
    },
  },
  YARD: {
    SUCCESS: {
      ASSIGN_CLIENTS: i18n.t('messages.yard.success.assignClients'),
      DEACTIVATED_CLIENTS: i18n.t('messages.yard.success.deactivatedClients'),
      REACTIVATED_CLIENTS: i18n.t('messages.yard.success.reactivatedClients'),
      SEND_CONTRACT: i18n.t('messages.yard.success.sendContract'),
    },
    ERROR: {
      PLACE_NOT_FOUND: i18n.t('messages.yard.error.placeNotFound'),
      CLIENTS_NOT_ASSIGNED: i18n.t('messages.yard.error.clientsNotAssigned'),
      CLIENTS_NOT_DEACTIVATED: i18n.t('messages.yard.error.clientsNotDeactivated'),
      CLIENTS_NOT_REACTIVATED: i18n.t('messages.yard.error.clientsNotReactivated'),
      BLOCKS_SCENE_NOT_VALID: i18n.t('messages.yard.error.blocksSceneNotValid'),
    },
  },
  EMPLOYEE: {
    SUCCESS: {
      CREATED: i18n.t('messages.employee.success.created'),
      EDITED: i18n.t('messages.employee.success.edited'),
      ACTIVATED: i18n.t('messages.employee.success.activated'),
      DEACTIVATED: i18n.t('messages.employee.success.deactivated'),
    },
    ERROR: {
      NOT_CREATED: i18n.t('messages.employee.error.notCreated'),
    },
  },
  ACTIONS: {
    NOT_VALID: i18n.t('messages.actions.notValid'),
  },
  SHARE: {
    SUCCESS: {
      TITLE_IMAGES: i18n.t('messages.share.success.titleImages'),
    },
    API_NOT_SUPPORTED: i18n.t('messages.share.apiNotSupported'),
  },
  FILE: {
    FORMAT_NOT_VALID: (fileName: string) => i18n.t('messages.file.formatNotValid', { fileName }),
    IS_TOO_LARGE: (fileName: string) => i18n.t('messages.file.isTooLarge', { fileName }),
  },
  CONSTRUCTION: {
    HEADING: i18n.t('messages.construction.heading'),
  },
  ERROR_BOUNDARY: {
    HEADING: i18n.t('messages.errorBoundary.heading'),
    DEFAULT: i18n.t('messages.errorBoundary.default'),
    DETAIL: i18n.t('messages.errorBoundary.detail'),
  },
  NETWORK: {
    ERROR: i18n.t('messages.network.error'),
    BAD_RESPONSE: i18n.t('messages.network.badResponse'),
    TOO_MANY_REQUESTS: i18n.t('messages.network.tooManyRequests'),
    ALREADY_EXISTS: i18n.t('messages.network.alreadyExists'),
    WARNING: {
      TRY_AGAIN: i18n.t('messages.network.warning.tryAgain'),
      WIFI_ERROR: i18n.t('messages.network.warning.wifiError'),
    },
  },
};

export const INPUT_ERRORS = {
  REQUIRED: {
    DEFAULT: i18n.t('inputErrors.required.default'),
    YARD_COMPANY_NAME: i18n.t('inputErrors.required.yardCompanyName'),
    YARD_COMPANY: i18n.t('inputErrors.required.yardCompany'),
    YARD_NAME: i18n.t('inputErrors.required.yardName'),
    CLIENT_NAME: i18n.t('inputErrors.required.clientName'),
    CONTAINER_NUMBER: i18n.t('inputErrors.required.containerNumber'),
    CONTAINER_TYPE: i18n.t('inputErrors.required.containerType'),
    DRIVER_NAME: i18n.t('inputErrors.required.driverName'),
    LICENSE_PLATE_NUMBER: i18n.t('inputErrors.required.licensePlateNumber'),
    FREE_DAYS: i18n.t('inputErrors.required.freeDays'),
    STORAGE_FEE: i18n.t('inputErrors.required.storageFee'),
    GATE_IN_CRANE_FEE: i18n.t('inputErrors.required.gateInCraneFee'),
    GATE_OUT_CRANE_FEE: i18n.t('inputErrors.required.gateOutCraneFee'),
    NON_STANDART_TRANSPORT_FEE: i18n.t('inputErrors.required.nonStandardTransportFee'),
    DATE: i18n.t('inputErrors.required.date'),
    BOOKING_NUMBER: i18n.t('inputErrors.required.bookingNumber'),
    PRICE: i18n.t('inputErrors.required.price'),
    FEE: i18n.t('inputErrors.required.fee'),
    COMMENT: i18n.t('inputErrors.required.comment'),
    COMPANY_LEGAL_NAME: i18n.t('inputErrors.required.companyLegalName'),
    CODE: i18n.t('inputErrors.required.code'),
    STREET_ADDRESS: i18n.t('inputErrors.required.streetAddress'),
    CITY: i18n.t('inputErrors.required.city'),
    ZIP_CODE: i18n.t('inputErrors.required.zipCode'),
    COUNTRY: i18n.t('inputErrors.required.country'),
    CONTACT_PERSON_FIRST_NAME: i18n.t('inputErrors.required.contactPersonFirstName'),
    CONTACT_PERSON_LAST_NAME: i18n.t('inputErrors.required.contactPersonLastName'),
    CONTACT_PERSON_EMAIL: i18n.t('inputErrors.required.contactPersonEmail'),
    COMPANY_EMAIL: i18n.t('inputErrors.required.companyEmail'),
    COMPANY_PHONE_NUMBER: i18n.t('inputErrors.required.companyPhoneNumber'),
    EMAIL: i18n.t('inputErrors.required.email'),
    CONTACT_PERSON_PHONE_NUMBER: i18n.t('inputErrors.required.contactPersonPhoneNumber'),
    PHONE_NUMBER: i18n.t('inputErrors.required.phoneNumber'),
    FIRST_NAME: i18n.t('inputErrors.required.firstName'),
    LAST_NAME: i18n.t('inputErrors.required.lastName'),
    CURRENT_PASSWORD: i18n.t('inputErrors.required.currentPassword'),
    NEW_PASSWORD: i18n.t('inputErrors.required.newPassword'),
    NEW_PASSWORD_CONFIRM: i18n.t('inputErrors.required.newPasswordConfirm'),
    PASSWORD: i18n.t('inputErrors.required.password'),
    PASSWORD_CONFIRM: i18n.t('inputErrors.required.passwordConfirm'),
    COMPANY: i18n.t('inputErrors.required.company'),
    DESCRIPTION: i18n.t('inputErrors.required.description'),
    DAYS_TO_COMPLETE: i18n.t('inputErrors.required.daysToComplete'),
    IMAGES: i18n.t('inputErrors.required.images'),
    MESSENGER_NAME: i18n.t('inputErrors.required.messengerName'),
    MESSENGER_IDENTIFIER: i18n.t('inputErrors.required.messengerIdentifier'),
    FILE_NAME: i18n.t('inputErrors.required.fileName'),
    BLOCK: i18n.t('inputErrors.required.block'),
    ROW: i18n.t('inputErrors.required.row'),
    SLOT: i18n.t('inputErrors.required.slot'),
    TIER: i18n.t('inputErrors.required.tier'),
  },
  NOT_VALID: {
    YARD_COMPANY: i18n.t('inputErrors.notValid.yardCompany'),
    YARD_NAME: i18n.t('inputErrors.notValid.yardName'),
    YARD_NAME_LENGTH: i18n.t('inputErrors.notValid.yardNameLength'),
    CONTAINERS: i18n.t('inputErrors.notValid.containers'),
    CONTAINER_NUMBER: i18n.t('inputErrors.notValid.containerNumber'),
    CONTAINER_NUMBER_SHORT: i18n.t('inputErrors.notValid.containerNumberShort'),
    CONTAINER_NUMBER_MIN: i18n.t('inputErrors.notValid.containerNumberMin'),
    DRIVER_NAME: i18n.t('inputErrors.notValid.driverName'),
    LICENSE_PLATE_NUMBER: i18n.t('inputErrors.notValid.licensePlateNumber'),
    LICENSE_PLATE_NUMBER_LENGTH: i18n.t('inputErrors.notValid.licensePlateNumberLength'),
    FREE_DAYS: i18n.t('inputErrors.notValid.freeDays'),
    STORAGE_FEE: i18n.t('inputErrors.notValid.storageFee'),
    GATE_IN_CRANE_FEE: i18n.t('inputErrors.notValid.gateInCraneFee'),
    GATE_OUT_CRANE_FEE: i18n.t('inputErrors.notValid.gateOutCraneFee'),
    NON_STADART_TRANSPORT_FEE: i18n.t('inputErrors.notValid.nonStandardTransportFee'),
    DATE: i18n.t('inputErrors.notValid.date'),
    PRICE: i18n.t('inputErrors.notValid.price'),
    PRICE_MIN_VALUE: i18n.t('inputErrors.notValid.priceMinValue'),
    DAYS_TO_COMPLETE_MIN_VALUE: i18n.t('inputErrors.notValid.daysToCompleteMinValue'),
    COMPANY_LEGAL_NAME: i18n.t('inputErrors.notValid.companyLegalName'),
    COMPANY_LEGAL_NAME_LENGTH: i18n.t('inputErrors.notValid.companyLegalNameLength'),
    CODE: i18n.t('inputErrors.notValid.code'),
    CODE_LENGTH: i18n.t('inputErrors.notValid.codeLength'),
    STREET_ADDRESS: i18n.t('inputErrors.notValid.streetAddress'),
    STREET_ADDRESS_LENGTH: i18n.t('inputErrors.notValid.streetAddressLength'),
    CITY: i18n.t('inputErrors.notValid.city'),
    CITY_LENGTH: i18n.t('inputErrors.notValid.cityLength'),
    ZIP_CODE: i18n.t('inputErrors.notValid.zipCode'),
    ZIP_CODE_LENGTH: i18n.t('inputErrors.notValid.zipCodeLength'),
    COUNTRY: i18n.t('inputErrors.notValid.country'),
    COUNTRY_LENGTH: i18n.t('inputErrors.notValid.countryLength'),
    CONTACT_PERSON_FIRST_NAME: i18n.t('inputErrors.notValid.contactPersonFirstName'),
    CONTACT_PERSON_FIRST_NAME_LENGTH: i18n.t('inputErrors.notValid.contactPersonFirstNameLength'),
    CONTACT_PERSON_LAST_NAME: i18n.t('inputErrors.notValid.contactPersonLastName'),
    CONTACT_PERSON_LAST_NAME_LENGTH: i18n.t('inputErrors.notValid.contactPersonLastNameLength'),
    CONTACT_PERSON_EMAIL: i18n.t('inputErrors.notValid.contactPersonEmail'),
    COMPANY_EMAIL: i18n.t('inputErrors.notValid.companyEmail'),
    COMPANY_EMAIL_LENGTH: i18n.t('inputErrors.notValid.companyEmailLength'),
    COMPANY_PHONE_NUMBER: i18n.t('inputErrors.notValid.companyPhoneNumber'),
    COMPANY_PHONE_NUMBER_LENGTH: i18n.t('inputErrors.notValid.companyPhoneNumberLength'),
    EMAIL: i18n.t('inputErrors.notValid.email'),
    EMAIL_LENGTH: i18n.t('inputErrors.notValid.emailLength'),
    CONTACT_PERSON_PHONE_NUMBER: i18n.t('inputErrors.notValid.contactPersonPhoneNumber'),
    CONTACT_PERSON_PHONE_NUMBER_LENGTH: i18n.t(
      'inputErrors.notValid.contactPersonPhoneNumberLength',
    ),
    PHONE_NUMBER: i18n.t('inputErrors.notValid.phoneNumber'),
    PHONE_NUMBER_LENGTH: i18n.t('inputErrors.notValid.phoneNumberLength'),
    FIRST_NAME: i18n.t('inputErrors.notValid.firstName'),
    FIRST_NAME_LENGTH: i18n.t('inputErrors.notValid.firstNameLength'),
    LAST_NAME: i18n.t('inputErrors.notValid.lastName'),
    LAST_NAME_LENGTH: i18n.t('inputErrors.notValid.lastNameLength'),
    USERNAME_LENGTH: i18n.t('inputErrors.notValid.usernameLength'),
    NEW_PASSWORD: i18n.t('inputErrors.notValid.newPassword'),
    NEW_PASSWORD_LENGTH: i18n.t('inputErrors.notValid.newPasswordLength'),
    NOT_NEW_PASSWORD: i18n.t('inputErrors.notValid.notNewPassword'),
    CURRENT_PASSWORD: i18n.t('inputErrors.notValid.currentPassword'),
    CURRENT_PASSWORD_LENGTH: i18n.t('inputErrors.notValid.currentPasswordLength'),
    PASSWORD: i18n.t('inputErrors.notValid.password'),
    PASSWORD_LENGTH: i18n.t('inputErrors.notValid.passwordLength'),
    NEW_PASSWORD_CONFIRM: i18n.t('inputErrors.notValid.newPasswordConfirm'),
    PASSWORD_CONFIRM: i18n.t('inputErrors.notValid.passwordConfirm'),
    COMPANY: i18n.t('inputErrors.notValid.company'),
    BOOKING_NUMBER: i18n.t('inputErrors.notValid.bookingNumber'),
    BOOKING_NUMBER_LENGTH: i18n.t('inputErrors.notValid.bookingNumberLength'),
    COMMENT: i18n.t('inputErrors.notValid.comment'),
    COMMENT_LENGTH: i18n.t('inputErrors.notValid.commentLength'),
    REPAIR_DESCRIPTION_LENGTH: i18n.t('inputErrors.notValid.repairDescriptionLength'),
    SALE_DESCRIPTION_LENGTH: i18n.t('inputErrors.notValid.saleDescriptionLength'),
    MAX_UPLOAD_FILES: i18n.t('inputErrors.notValid.maxUploadFiles'),
    MESSENGER_NAME_LENGTH: i18n.t('inputErrors.notValid.messengerNameLength'),
    MESSENGER_IDENTIFIER_LENGTH: i18n.t('inputErrors.notValid.messengerIdentifierLength'),
    FILE_NAME_LENGTH: i18n.t('inputErrors.notValid.fileNameLength'),
    BLOCK_NAME_LENGTH: i18n.t('inputErrors.notValid.blockListLength'),
    BLOCK_ROWS: i18n.t('inputErrors.notValid.blockRows'),
    BLOCK_SLOTS: i18n.t('inputErrors.notValid.blockSlots'),
  },
};

export const TOOLTIP = {
  PASSWORD_SYMBOLS: i18n.t('tooltip.passwordSymbols'),
  PASSWORD_MIN: i18n.t('tooltip.passwordMin'),
  PASSWORD_MAX: i18n.t('tooltip.passwordMax'),
};
